export class ConceptoPlanilla {
  idconcepto?: number;
  codigo?: string;
  nombre?: string;
  tipo?: string;
  es_fijo?: boolean;
  aplica_essalud?: boolean;
  aplica_cts?: boolean;
  editando?: boolean;
  constructor() { this.tipo = 'H'; this.es_fijo = true; this.aplica_essalud = false; this.aplica_cts = false; }
}
